import { TRIGGER_TYPES, TRIGGER_NAMES } from "constants/flowDesigner";

const triggers = [
  {
    type: TRIGGER_TYPES.REST_ENDPOINT,
    label: TRIGGER_NAMES.REST_ENDPOINT,
    properties: {
      inputData: {
        method: ["GET"],
        headers: [],
        params: [],
        body: {}
      },
      outputData: { headers: [], body: {} },
      respond: {value: "last_node_finishes"},
    }
  },
  {
    type: TRIGGER_TYPES.WEBHOOK,
    label: TRIGGER_NAMES.WEBHOOK,
    properties: {}
  },
  {
    type: TRIGGER_TYPES.SCHEDULE,
    label: TRIGGER_NAMES.SCHEDULE,
    properties: {}
  },
  {
    type: TRIGGER_TYPES.REDIS,
    label: TRIGGER_NAMES.REDIS,
    properties: {}
  },
  {
    type: TRIGGER_TYPES.BLUE_PRISM_DELTA,
    label: TRIGGER_NAMES.BLUE_PRISM_DELTA,
    properties: {}
  },
  {
    type: TRIGGER_TYPES.SOCKET_IO,
    label: TRIGGER_NAMES.SOCKET_IO,
    properties: {}
  },
  {
    type: TRIGGER_TYPES.MCP,
    label: TRIGGER_NAMES.MCP,
    properties: {},
  }
];

export default triggers;
